module.exports = __webpack_public_path__ + "img/img_video.bf363bfd.svg";